import { Component } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import {
  LangChangeEvent,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { messageVisibility } from '../../../../models/messageVisibility.model';
import {
  GeneralDiscountCatalogDto,
  GeneralDiscountCatalogRequest,
  GeneralDiscountCatalogResponse,
} from '../../../../models/discountGeneralCatalog/GeneralDiscountCatalogDto.model';
import { DiscountService } from '../../../../services/discountService.service';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../../services/shared.service';
import { ManudalValidation } from '../../../../models/enums/manudal-validation';

@Component({
  selector: 'app-catalog-discount',
  standalone: true,
  imports: [
    HeaderComponent,
    NavbarComponent,
    SidebarComponent,
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    PaginatorComponent,
    AlertComponentComponent,
  ],
  templateUrl: './catalog-discount.component.html',
  styleUrl: './catalog-discount.component.css',
})
export class CatalogDiscountComponent {
  links: any[] = []; // Lista de links para el sidebar
  discountReponse: GeneralDiscountCatalogResponse = new GeneralDiscountCatalogResponse();
  discountRequest: GeneralDiscountCatalogRequest = new GeneralDiscountCatalogRequest();
  discountSelected: GeneralDiscountCatalogDto = new GeneralDiscountCatalogDto();
  selectedRowId: number | null = null;
  discountForm!: FormGroup;
  isCreate: boolean = false;
  errorMessage: string = '';
  messageVisibility: messageVisibility = new messageVisibility();
  private langChangeSubscription!: Subscription;

  manualValidationEnum: ManudalValidation[] = Object.values(ManudalValidation);

  constructor(
    private translateService: TranslateService,
    private routelinks: RoutelinksService,
    private discountService: DiscountService,
    private formBuilder: FormBuilder,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.links = this.routelinks.linksDiscount;
    this.initFormReactiveDiscount();
    this.loadDiscounts();
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.loadDiscounts();
      }
    );
    this.discountForm.get('importType')?.valueChanges.subscribe((value) => {
      value == 'I'
        ? this.discountForm.get('discountPercentage')?.patchValue(0)
        : null;
      value == 'P'
        ? this.discountForm.get('discountFixedAmount')?.patchValue(0)
        : null;
    });

    // Activa la notifiación de cambio de pagina en el paginador
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.discountRequest.pageRequest.page = page;
      this.loadDiscounts();
    });
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  private initFormReactiveDiscount(): void {
    this.discountForm = this.formBuilder.group({
      idGeneralDiscountCatalog: [0],
      discountCode: ['', [Validators.required]],
      active: new FormControl('S'),
      importType: ['I'],
      discountFixedAmount: [0],
      discountIndicatorDocumentation: [],
      discountPercentage: [0],
      discountTypology: [''],
      manualValidation: [''],
      applicationOrderNumber: [0],
      descriptionCat: ['', [Validators.required]],
      descriptionCas: ['', [Validators.required]],
      descriptionEng: ['', [Validators.required]],
      infoDiscountCat: ['', [Validators.required]],
      infoDiscountCas: ['', [Validators.required]],
      infoDiscountEng: ['', [Validators.required]],
      infoDocumentationCat: [''],
      infoDocumentationCas: [''],
      infoDocumentationEng: [''],
      sensitiveDataEncodedDescriptionCat: [''],
      sensitiveDataEncodedDescriptionCas: [''],
      sensitiveDataEncodedDescriptionEng: [''],
    });
    this.discountForm.get('importType')?.patchValue('I');
  }

  loadDiscounts() {
    this.discountService
      .getListGeneralDiscountCatalog(this.discountRequest.pageRequest)
      .subscribe({
        next: (response) => {
          if (response != null) {
            this.discountReponse.GeneralDiscountCatalogDto =
              response.listGeneralDiscountCatalog.map((rt: any) => {
                return {
                  ...rt,
                  generalDiscountCatalogTraductionDto:
                    rt.generalDiscountCatalogTraductionDto.filter((t: any) =>
                      t.languageDto.code.includes(
                        this.translateService.currentLang || 'es'
                      )
                    ),
                };
              });
            response.pageDto !== undefined
              ? (this.discountReponse.pageDto = response.pageDto)
              : null;
          }
        },
        error: (error) => {
          console.log('Se ha producido un error', error);
        },
      });
  }

  createOrUpdateDiscount() {
    //modo creacion
    if (this.discountForm.valid) {
      this.buildDiscountDto();
      if (!this.selectedRowId) {
        this.discountService
          .insertGeneralDiscountCatalog(
            this.discountRequest.GeneralDiscountCatalogDto
          )
          .subscribe({
            next: () => {
              this.messageVisibility.isErrorFirts = false;
              this.messageVisibility.isSuccessFirst = true;
              this.errorMessage = "S'ha creat correctament";
              this.isCreate = false;
              this.selectedRowId = null;
              this.discountForm.reset();
              this.loadDiscounts();
            },
            error: (error) => {
              this.messageVisibility.isErrorFirts = true;
              this.messageVisibility.isSuccessFirst = false;
              this.errorMessage = error.error.message;
            },
          });
      }
      //modo edicion
      else {
        this.discountService
          .updateGeneralDiscountCatalog(
            this.discountRequest.GeneralDiscountCatalogDto
          )
          .subscribe({
            next: () => {
              this.messageVisibility.isErrorFirts = false;
              this.messageVisibility.isSuccessFirst = true;
              this.errorMessage = "S'ha editat correctament";
              this.loadDiscounts();
            },
            error: (error) => {
              this.messageVisibility.isErrorFirts = true;
              this.messageVisibility.isSuccessFirst = false;
              this.errorMessage = error.error.message;
            },
          });
      }
    } else {
      this.messageVisibility.isErrorFirts = true;
      this.messageVisibility.isSuccessFirst = false;
      this.errorMessage = 'obligatorios';
    }
  }

  private buildDiscountDto(): void {
    if (this.selectedRowId) {
      this.discountRequest.GeneralDiscountCatalogDto.idGeneralDiscountCatalog =
        this.selectedRowId || undefined; // Asigna el ID de la tasa académica seleccionada
      this.discountRequest.GeneralDiscountCatalogDto.generalDiscountCatalogTraductionDto =
        [
          {
            languageDto: { idLanguage: 1 },
            discountDescription: undefined,
            idGeneralDiscountCatalogTraduction:
              this.discountSelected.generalDiscountCatalogTraductionDto?.filter(
                (serv) => {
                  return serv.languageDto?.idLanguage == 1;
                }
              )[0].idGeneralDiscountCatalogTraduction,
          },
          {
            languageDto: { idLanguage: 2 },
            discountDescription: undefined,
            idGeneralDiscountCatalogTraduction:
              this.discountSelected.generalDiscountCatalogTraductionDto?.filter(
                (serv) => {
                  return serv.languageDto?.idLanguage == 2;
                }
              )[0].idGeneralDiscountCatalogTraduction,
          },
          {
            languageDto: { idLanguage: 3 },
            discountDescription: undefined,
            idGeneralDiscountCatalogTraduction:
              this.discountSelected.generalDiscountCatalogTraductionDto?.filter(
                (serv) => {
                  return serv.languageDto?.idLanguage == 3;
                }
              )[0].idGeneralDiscountCatalogTraduction,
          },
        ];
    } else {
      this.discountRequest.GeneralDiscountCatalogDto =
        new GeneralDiscountCatalogDto(); // Inicializa de 0 el objeto
      if (
        this.discountRequest.GeneralDiscountCatalogDto
          .generalDiscountCatalogTraductionDto
      ) {
        this.discountRequest.GeneralDiscountCatalogDto.generalDiscountCatalogTraductionDto =
          [
            {
              languageDto: { idLanguage: 1 },
              idGeneralDiscountCatalogTraduction: undefined,
              discountDescription: undefined,
            },
            {
              languageDto: { idLanguage: 2 },
              idGeneralDiscountCatalogTraduction: undefined,
              discountDescription: undefined,
            },
            {
              languageDto: { idLanguage: 3 },
              idGeneralDiscountCatalogTraduction: undefined,
              discountDescription: undefined,
            },
          ];
      }
    }

    this.discountRequest.GeneralDiscountCatalogDto.discountCode =
      this.discountForm.get('discountCode')?.value;
    this.discountRequest.GeneralDiscountCatalogDto.applicationOrderNumber =
      this.discountForm.get('applicationOrderNumber')?.value;
    this.discountRequest.GeneralDiscountCatalogDto.discountFixedAmount =
      this.discountForm.get('discountFixedAmount')?.value;
    this.discountRequest.GeneralDiscountCatalogDto.discountPercentage =
      this.discountForm.get('discountPercentage')?.value;
    this.discountRequest.GeneralDiscountCatalogDto.discountTypology =
      this.discountForm.get('discountTypology')?.value;
    this.discountRequest.GeneralDiscountCatalogDto.active =
      this.discountForm.get('active')?.value;
    this.discountRequest.GeneralDiscountCatalogDto.manualValidation =
      this.discountForm.get('manualValidation')?.value;
    this.discountForm.get('discountIndicatorDocumentation')?.value
      ? (this.discountRequest.GeneralDiscountCatalogDto.discountIndicatorDocumentation =
          'S')
      : (this.discountRequest.GeneralDiscountCatalogDto.discountIndicatorDocumentation =
          'N'); // Asigna el estado activo

    this.discountRequest.GeneralDiscountCatalogDto.generalDiscountCatalogTraductionDto?.forEach(
      (translation) => {
        if (
          translation.languageDto?.code === 'es' ||
          translation.languageDto?.idLanguage === 1
        ) {
          translation.discountDescription =
            this.discountForm.get('descriptionCas')?.value ?? undefined;
          translation.infoDiscount =
            this.discountForm.get('infoDiscountCas')?.value ?? undefined;
          translation.sensitiveDataEncodedDescription =
            this.discountForm.get('sensitiveDataEncodedDescriptionCas')
              ?.value ?? undefined;
          translation.infoDocumentation =
            this.discountForm.get('infoDocumentationCas')?.value ?? undefined;
        } else if (
          translation.languageDto?.code === 'ca' ||
          translation.languageDto?.idLanguage === 2
        ) {
          translation.discountDescription =
            this.discountForm.get('descriptionCat')?.value ?? undefined;
          translation.infoDiscount =
            this.discountForm.get('infoDiscountCat')?.value ?? undefined;
          translation.sensitiveDataEncodedDescription =
            this.discountForm.get('sensitiveDataEncodedDescriptionCat')
              ?.value ?? undefined;
          translation.infoDocumentation =
            this.discountForm.get('infoDocumentationCat')?.value ?? undefined;
        } else if (
          translation.languageDto?.code === 'en' ||
          translation.languageDto?.idLanguage === 3
        ) {
          translation.discountDescription =
            this.discountForm.get('descriptionEng')?.value ?? undefined;
          translation.infoDiscount =
            this.discountForm.get('infoDiscountEng')?.value ?? undefined;
          translation.sensitiveDataEncodedDescription =
            this.discountForm.get('sensitiveDataEncodedDescriptionEng')
              ?.value ?? undefined;
          translation.infoDocumentation =
            this.discountForm.get('infoDocumentationEng')?.value ?? undefined;
        }
      }
    );
  }

  checkRow(discount?: GeneralDiscountCatalogDto) {
    if (discount) {
      if (this.selectedRowId === discount.idGeneralDiscountCatalog) {
        this.selectedRowId = null;
        return;
      }
      // Modo edición
      this.discountService
        .getListGeneralDiscountCatalogById(discount.idGeneralDiscountCatalog)
        .subscribe((response) => {
          this.patchDiscountForm(response);
          this.discountSelected = response;
          this.discountForm.get('idGeneralDiscountCatalog')?.disable();
          this.selectedRowId = Number(response.idGeneralDiscountCatalog);
          this.isCreate = false;
          response.discountPercentage > 0
            ? this.discountForm.get('importType')?.patchValue('P')
            : this.discountForm.get('importType')?.patchValue('I');

          response.generalDiscountCatalogTraductionDto?.forEach(
            (discount: any) => {
              if (discount.languageDto?.code == 'es') {
                this.discountForm
                  .get('descriptionCas')
                  ?.patchValue(discount.discountDescription);
                this.discountForm
                  .get('infoDiscountCas')
                  ?.patchValue(discount.infoDiscount);
                this.discountForm
                  .get('infoDocumentationCas')
                  ?.patchValue(discount.infoDocumentation);
                this.discountForm
                  .get('sensitiveDataEncodedDescriptionCas')
                  ?.patchValue(discount.sensitiveDataEncodedDescription);
              }
              if (discount.languageDto?.code == 'ca') {
                this.discountForm
                  .get('descriptionCat')
                  ?.patchValue(discount.discountDescription);
                this.discountForm
                  .get('infoDiscountCat')
                  ?.patchValue(discount.infoDiscount);
                this.discountForm
                  .get('infoDocumentationCat')
                  ?.patchValue(discount.infoDocumentation);
                this.discountForm
                  .get('sensitiveDataEncodedDescriptionCat')
                  ?.patchValue(discount.sensitiveDataEncodedDescription);
              }
              if (discount.languageDto?.code == 'en') {
                this.discountForm
                  .get('descriptionEng')
                  ?.patchValue(discount.discountDescription);
                this.discountForm
                  .get('infoDiscountEng')
                  ?.patchValue(discount.infoDiscount);
                this.discountForm
                  .get('infoDocumentationEng')
                  ?.patchValue(discount.infoDocumentation);
                this.discountForm
                  .get('sensitiveDataEncodedDescriptionEng')
                  ?.patchValue(discount.sensitiveDataEncodedDescription);
              }
            }
          );
        });
    } else {
      // Modo creación
      this.selectedRowId = null;
      this.isCreate = true;
      this.discountForm.enable();
      this.discountForm.reset();
      this.discountForm.patchValue({
        active: true,
        importType: 'I',
      });
    }
    window.scrollTo(0, 600);
  }

  patchDiscountForm(discount: GeneralDiscountCatalogDto) {
    this.discountForm.patchValue({
      idGeneralDiscountCatalog: discount.idGeneralDiscountCatalog,
      active: discount.active,
      applicationOrderNumber: discount.applicationOrderNumber,
      discountCode: discount.discountCode,
      discountFixedAmount: discount.discountFixedAmount,
      discountIndicatorDocumentation:
        discount.discountIndicatorDocumentation == 'S' ? true : false,
      discountPercentage: discount.discountPercentage,
      discountTypology: discount.discountTypology,
      manualValidation: discount.manualValidation,
    });
  }
}
